import { combineReducers } from "redux";
import loginReducer from "./loginReducer";
import messageReducer from "./messageReducer";

export default combineReducers({
  user: loginReducer,
  message: messageReducer,
});
